export default {
  sendEmail: 'Send e-mail',
  export: 'Export',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  replyToMessage: 'Reply message',
};
